import { EntidadeBase } from 'hay-core-react';
class PesquisaExecucaoLogModel extends EntidadeBase {
    constructor() {
        super('pesquisaexecucaolog');
    }
}
const instance = new PesquisaExecucaoLogModel();
export default instance;
